export default __webpack_public_path__ + "static/media/user-play.d8080d46.png";